/**
 * Historique des versions, affiché dans les réglages.
 *
 * # Pourquoi une liste TypeScript et non un CHANGELOG.md analysé
 *
 * Analyser du markdown à la compilation ajouterait un format à respecter, un
 * analyseur à maintenir et une classe d'erreurs qui n'apparaîtraient qu'au
 * build. Une liste typée est vérifiée par le compilateur, se rend directement,
 * et `tests/changelog.test.ts` garantit qu'elle reste cohérente avec la
 * version déclarée dans `package.json` — impossible de publier une version
 * sans l'avoir décrite.
 *
 * # Ce qu'on y écrit
 *
 * Ce qui change **pour les deux personnes qui utilisent l'application**, dans
 * leurs mots. Pas les refactorisations, pas les commits : le journal de bord
 * technique, c'est `git log`.
 *
 * La liste est ordonnée de la plus récente à la plus ancienne.
 */

export interface Release {
  /** Version sémantique, telle qu'elle figure dans `package.json`. */
  version: string;
  /** Date de publication, `AAAA-MM-JJ`. */
  date: string;
  changes: string[];
}

export const CHANGELOG: readonly Release[] = [
  {
    version: '1.1.0',
    date: '2026-08-23',
    changes: [
      'Réorganisation des articles : maintenir la poignée à gauche d’une ligne et glisser. La liste défile toute seule près des bords, et les flèches haut et bas fonctionnent au clavier.',
      'Correction des zones noires apparaissant dans la liste sur Android pendant le défilement.',
      'Correction de lignes qui se superposaient ou laissaient un trou après un déplacement.',
      'Cet écran : suivi des versions, avec la version réellement installée sur cet appareil.',
    ],
  },
  {
    version: '1.0.0',
    date: '2026-07-30',
    changes: [
      'Première version : listes de courses partagées entre deux appareils.',
      'Fonctionne hors ligne — les modifications partent au retour du réseau, rien n’est perdu.',
      'Plusieurs listes, quantités, suggestions à la frappe, traçabilité « Ajouté par ».',
      'Thème clair, sombre ou automatique, propre à chaque téléphone.',
      'Accès par lien de foyer, sans compte ni mot de passe.',
    ],
  },
];
